import React from 'react';
import { DisplayContainer, Section } from '../../components';
import { images } from './config';
import '../index.scss';

const Traditional = () => {
    return (
        <Section
            title='traditional art'
        >
            <DisplayContainer
                images={images}
            />
        </Section>
    )
}

export default Traditional;